import { render, staticRenderFns } from "./CategorizedInsurancesCard.vue?vue&type=template&id=150761b4"
import script from "./CategorizedInsurancesCard.vue?vue&type=script&lang=js"
export * from "./CategorizedInsurancesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports